import React, { useEffect, useMemo, useRef, useState } from 'react';
import { Button, Progress } from 'tea-component';
import Marquee from './components/marquee';
import { getAigcSummary } from './utils';
import { useIntl } from 'umi';
import SvgIcon from '@/pages/home/components/SvgIcon';
import './styles/index.scss';
import CardCommon from '../CardCommon';
import { mdContentToHtml, replaceGptText } from '@op/utils/text';
import { DBO_T } from '@op/utils/format';
import DOMPurify from 'dompurify';
export default function AigcCard({
  config,
  params,
  total,
  contentCard = false,
  hasTitle = true,
  hasDownload = true,
  setAigcContent,
  downloadTips,
  defaultSummary = '',
  stopAction,
  customTitle,
  errAction,
  onHandleStop,
}: {
  config: any;
  params: any;
  total: number;
  contentCard?: boolean;
  hasTitle?: boolean;
  hasDownload?: boolean;
  downloadTips?: string;
  setAigcContent?: (value: string) => void;
  defaultSummary?: string;
  stopAction?: () => void;
  customTitle?: string | JSX.Element;
  errAction?: () => void;
  onHandleStop?: (handleStop: () => void) => void;
}) {
  const { formatMessage } = useIntl();

  const [status, setStatus] = useState<'loading' | 'success' | 'failed'>(
    'loading',
  );
  const theme =
    status === 'loading'
      ? 'default'
      : status === 'failed'
      ? 'danger'
      : 'success';
  const [summary, setSummary] = useState('');

  const stopRef = useRef<any>(null);
  const stopTarget = useRef(false);
  const { prompt = '', resultType = '' } = config;

  const marqueeList = [
    'GPT will take 1 to 3 minutes, depending on the content.',
    'Please do not close this page.',
  ];

  const [percent, setPercent] = useState(1);
  let localePercent = 0;

  let interval: any = useRef(null);
  const intervalTime = 500;

  function initState(defaultSummary = '') {
    setSummary(defaultSummary);
    setAigcContent?.(defaultSummary);
    clearInterval(interval.current);
  }
  const fetchData = async () => {
    setStatus('loading');
    initState();
    stopRef.current = null;
    stopTarget.current = false;
    interval.current = setInterval(() => {
      localePercent = Math.min(localePercent + 1, 99);
      setPercent(localePercent);
    }, intervalTime);

    const { status, data } = await getAigcSummary({
      params,
      prompt,
      stop: stopRef,
      cancelCallback: () => stopTarget.current,
    });

    if (status === 'cancel') {
    } else if (status === 'success') {
      handleSuccess(data || '');
    } else {
      handleError();
    }
  };

  function handleSuccess(summary: string) {
    clearInterval(interval.current);
    setPercent(100);
    setAigcContent?.(summary);
    setSummary(summary);
    setStatus('success');
  }

  function handleError() {
    clearInterval(interval.current);
    setPercent(100);
    setStatus('failed');
    errAction?.();
  }

  function handleStop() {
    stopTarget.current = true;
    stopRef.current?.();
    initState();
    stopAction?.();
  }

  useEffect(() => {
    initState(defaultSummary);
    onHandleStop?.(handleStop);
  }, [defaultSummary]);

  useEffect(() => {
    if (!prompt || !resultType) return;
    localePercent = 0;
    setPercent(0);
    if (resultType === 'download') {
      console.log('跳转下载页面');
    } else {
      console.log('本页面下载');
      if (!defaultSummary) {
        fetchData();
      }
    }
  }, [config, defaultSummary]);

  const renderHtml = useMemo(() => {
    if (!summary) return null;

    const replacedSummary = replaceGptText(summary);

    const { html } = mdContentToHtml(replacedSummary);

    return html;
  }, [summary]);

  if ((!prompt || !resultType) && !defaultSummary) return null;

  return (
    // <div >
    //   {/* <Card>
    //     <Card.Header className="dbo-aigc-card-header">
    //       {summary && status !== 'failed' ? (
    //         <div className="dbo-aigc-card-header-download">
    //           <SvgIcon type="download" />
    //         </div>
    //       ) : null}
    //     </Card.Header>
    //   </Card> */}
    //   {/* 统一用一个组件 下载先注释 ，产品说后面加的话重新提单子更改 */}
    // </div>
    <CardCommon
      className="dbo-aigc-card-wrapper"
      title={
        hasTitle ? customTitle || formatMessage({ id: 'GPT Summary' }) : ''
      }
      downloadIcon="datalab-copy"
      downLoadTips={downloadTips}
      contentCard={contentCard}
      hasDownload={hasDownload && !!summary}
      handleDownloadOnClick={() => {
        if (!summary) return false;
        DBO_T.copyText(summary, formatMessage);
      }}
    >
      {!summary ? (
        <div className="dbo-aigc-card-content-wrapper">
          <div className="dbo-aigc-card-content-inner">
            {status === 'failed' ? (
              <div className="dbo-aigc-card-content-erry">
                <SvgIcon
                  type="erry-icontip"
                  className="dbo-aigc-card-content-icon"
                />
                <span>
                  {formatMessage({
                    id: 'Information overload, please reduce reviews and try again',
                  })}
                </span>
              </div>
            ) : (
              <>
                <div>
                  <p>
                    {formatMessage({
                      id: 'Generating a summary now using GPT-4',
                    })}

                    {total && (
                      <>
                        (
                        {formatMessage(
                          { id: '{total} Reviews are included' },
                          { total },
                        )}
                        )
                      </>
                    )}
                  </p>
                  <Progress
                    width={'100%'}
                    theme={theme}
                    percent={percent}
                    style={{ height: 4 }}
                  />
                  <div className="dbo-aigc-card-marquee">
                    <Marquee list={marqueeList}></Marquee>
                    <span className="dbo-aigc-card-percent">{percent}%</span>
                  </div>
                </div>
                {stopAction && (
                  <div className="dbo-aigc-btn-stop">
                    <Button type="weak" onClick={handleStop}>
                      {formatMessage({ id: 'Stop' })}
                    </Button>
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      ) : (
        <div className="dbo-aigc-card-summary">
          <span
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(renderHtml as string),
            }}
          ></span>
        </div>
      )}
    </CardCommon>
  );
}
